import axios from "axios";

const getAuthToken = () => {
  const Token = localStorage.getItem("token");
  return Token ?? undefined;
};

// Global auth modal reference
let globalAuthModal = null;

// Function to set the global auth modal reference
export const setGlobalAuthModal = (authModal) => {
  globalAuthModal = authModal;
};

export const AppInstance = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
  withCredentials: true,
  withXSRFToken: true,
  crossDomain: true,
});

AppInstance.interceptors.request.use(
  (config) => {
    const token = getAuthToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

AppInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error?.response?.status === 401) {
      // Clear the token from localStorage
      localStorage.removeItem("token");

      // Show login modal if available
      if (globalAuthModal) {
        globalAuthModal.openAuthModal("login");
      }
    }
    return Promise.reject(error);
  }
);
